export default function Tips(){
  return (
    <section className="container py-16">
      <h1 className="text-4xl md:text-5xl font-bold mb-4">Travel Tips</h1>
      <div className="grid md:grid-cols-3 gap-6 mt-8">
        {Array.from({length:6}).map((_,i)=> (
          <div key={i} className="card p-6">
            <div className="font-semibold mb-2">Tip {i+1}</div>
            <p className="text-sm text-gray-600">Pack smart, arrive early, and keep copies of documents.</p>
          </div>
        ))}
      </div>
    </section>
  );
}
